module.exports = __webpack_public_path__ + "static/img/training_system_s1_max3.487ecc30.png";